export enum CustomObjectTypeEnum {
    CustomObject = 0,
    EndPoint = 1,
    Lookup = 2,
    EmployeeEndPoint = 3,
    LocationEndPoint = 4,
}
